<template>
  <div>
    <page-header title="Routes" breadcrumb="Dashboard >> Settings >> Routes" />
      <div class="lg:p-3 lg:bg-white rounded-lg">

        <div>
          <m-tab
              :tabs="tabs"
              :current-tab="currentTab"
              @current-tab="currentTab = $event"
            />
        </div>

        <div class="p-3">
          <terminal-to-Terminal-routes-data-table v-if="currentTab === 'terminalToTerminal'" />
          <terminal-to-door-routes-data-table v-if="currentTab === 'terminalToDoor'" />
          <door-to-door-routes-data-table v-if="currentTab === 'doorToDoor'" />
        </div>
        

      </div>
    
  </div>
</template>

<script>
import MTab from "./partials/MTab.vue";
import TerminalToTerminalRoutesDataTable from "./TerminalToTerminal/RoutesDataTable";
import TerminalToDoorRoutesDataTable from "./TerminalToDoor/RoutesDataTable";
import DoorToDoorRoutesDataTable from "./DoorToDoor/RoutesDataTable";
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    TerminalToDoorRoutesDataTable,
    TerminalToTerminalRoutesDataTable,
    DoorToDoorRoutesDataTable,
    MTab,
    PageHeader,
  },
  data() {
    return {
      tabs: [
        {
          id: "terminalToTerminal",
          value: "Terminal-to-Terminal",
        },
        {
          id: "terminalToDoor",
          value: "Terminal-to-Door",
        },
        {
          id: "doorToDoor",
          value: "Door-to-Door",
        },
      ],
      currentTab:'terminalToTerminal'
    };
  },
  mounted(){
    if(this.$route.query.tab){
      this.currentTab = this.$route.query.tab
    }
  }
};
</script>

<style></style>
